export const ADD_PAYMENT_METHOD_BUTTON = "Add Payment Method";
export const PAYMENT_METHODS = "Payment Methods";
export const PAYMENTS_SECURE = "Payments are 100% secure.";
export const UNABLED_TO_ADD_PAYMENT =
  "We are unable to add your payment method";
export const ADD_PAYMENT_AGAIN = "Please add your payment method again";
export const TRY_AGAIN = "Try Again";

export const BOOK_YOUR_FLIGHT = "Booking your flight";
export const SAVING_TRAVELERS_AND_CHECKING_AVAILABILITY =
  "Saving travelers and checking availability";
